import React, { useState, useEffect, useRef } from "react";
import AppLoading from "expo-app-loading";
import { View, StyleSheet, ScrollView, Text, Linking } from "react-native";
import { StackScreenProps } from "@react-navigation/stack";
import { placowki, godzinyPobran } from "../data/placowki";
import { Button, ClientCard } from "../components";
import { COLORS, FONTS, PLATFORM_WIDTH } from "../constants/ui";
import type { RootStackParamList, ILaboratory } from "../components/util";

type LabDetailsScreenProps = StackScreenProps<RootStackParamList, "LabDetails">;

export const LabDetails: React.FC<LabDetailsScreenProps> = ({ route }) => {
  const { labName } = route.params;
  // w adresie nazwa jest w postaci "salve-medica", wiec porownujemy po uproszczonej formie
  const slug = (t: string) =>
    t.toLowerCase().replace(/\s+/g, "-").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  const lab =
    placowki.find((p) => slug(p.name) === slug(labName)) ||
    placowki.find((p) => p.name === labName) ||
    null;

  if (lab === null) {
    return <AppLoading />;
  }

  const mapa =
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(lab.name + " " + lab.adress.street + " " + lab.adress.city);

  return (
    <View style={styles.container}>
      <ScrollView contentContainerStyle={styles.wrapper}>
        <View style={{ marginTop: 10, marginBottom: 10 }}>
          <ClientCard {...lab} addressBox />
        </View>
        <View style={styles.labDescription}>
          <Text style={{ fontWeight: "bold", marginBottom: 6 }}>
            Placówka rekomendowana
          </Text>
          <Text>
            Pobranie materiału do badań: {godzinyPobran.tydzien},{" "}
            {godzinyPobran.sobota}. Przychodnia czynna {lab.hours.from}-
            {lab.hours.to} od poniedziałku do piątku, w soboty 8:00-14:00.
            Dane ze strony salve.pl, stan na 5.11.2026. Godziny potrafią się
            zmieniać, więc przed wizytą warto je potwierdzić telefonicznie.
          </Text>
        </View>
        <Button
          color={COLORS.TEAL}
          textColor={COLORS.BLACK}
          onPress={() => Linking.openURL("tel:" + lab.tel.replace(/\s/g, ""))}
        >
          Zadzwoń i umów badanie
        </Button>
        <View style={{ height: 12 }} />
        <Button
          color={COLORS.TEAL}
          textColor={COLORS.BLACK}
          onPress={() => Linking.openURL(mapa)}
        >
          Pokaż dojazd
        </Button>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    backgroundColor: COLORS.LIGHTBLUE,
  },
  wrapper: {
    justifyContent: "flex-start",
    width: PLATFORM_WIDTH,
    backgroundColor: COLORS.DARKBLUE,
    padding: 30,
    borderTopRightRadius: 30,
  },
  mapWrapper: {
    borderRadius: 15,
    alignItems: "center",
    overflow: "hidden",
  },
  labDescription: {
    backgroundColor: COLORS.WHITE,
    marginTop: 30,
    padding: 20,
    fontFamily: FONTS.LexendDeca_400,
    fontSize: 12,
    borderRadius: 15,
  },
});
